export const APP_DATA_KEY = '__TRIBE_DATA__'
export const STATIC_SERVER_STYLES = '__app-static-server-styles__'
export const APP_ROOT_ELEMENT_ID = 'root'
export enum AppsEnum {
  Giphy = 'giphy',
}
